import { FC } from 'react'
import { useQuery } from '@tanstack/react-query'
import { taxisAPI } from '../../../../api/vehicle/taxisAPI'
import { useSupplierState } from '../../../../Pages/Supplier/SupplierContext'
import ManageTaxi from './ManageVehicle'

interface Props {
  taxiId?: number
  backToSummaryFunction: Function
}

export const CreateTaxiHOC: FC<Props> = (props) => {
  const { taxis } = useSupplierState()
  const { taxiId, backToSummaryFunction } = props

  const { data: chargeRatesData } = useQuery({
    queryKey: ['getChargeRates', taxiId],
    queryFn: async () => {
      if (taxiId) {
        return taxisAPI.getChargeRatesByTaxiId(taxiId)
      }
      return null
    },
    enabled: !!taxiId,
    refetchOnWindowFocus: false,
  })
  const chargeRates = chargeRatesData?.data.value || []
  const taxi = taxis.find((v) => v.id === taxiId)
  return (
    <ManageTaxi
      taxi={taxi}
      exisitingChargeRates={chargeRates}
      backToSummaryFunction={backToSummaryFunction}
    />
  )
}
export default CreateTaxiHOC
